<template>
  <order-list :is-order-status="7"></order-list>
</template>

<script>
import OrderList from './components/OrderList'
export default {
  name: 'Refunding',
  components: {
    OrderList
  }
}
</script>
